






















































































import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import TtamScheduleTimezone from '../timezone/index.vue';
import { useTimeConverter } from './use-time-converter';
import { TimeZone, LocationData } from '../types';

const name = 'ttam-schedule-time-converter-dialog';

export default defineComponent({
  name,
  components: { TtamScheduleTimezone },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    onCloseDialog: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    timezoneStr: {
      type: String,
      default: '',
    },
    isDuration: {
      type: Boolean,
      default: false,
    },
    timezone: {
      type: String,
    },
    timezoneList: {
      type: Array as PropType<TimeZone[]>,
    },
    locationData: {
      type: Object as PropType<LocationData>,
      default: () => ({}),
      required: true,
    },
  },
  setup(props) {
    const { timeTableData, isLoading } = useTimeConverter(props);

    const spanMethod = ({ row, _, __, columnIndex }) => {
      if (columnIndex === 0) {
        return {
          rowspan: row.aggregatedRow,
          colspan: 1,
        };
      }
    };

    /** 2行以上时显示tips vui只支持1行以上显示 所以自行实现 */
    const showTips = (obj, row) => {
      // currentWidth 为文本在页面中所占的宽度，创建标签，加入到页面，获取currentWidth ,最后再移除
      let TemporaryTag = document.createElement('span');
      TemporaryTag.innerText = row.locations;
      TemporaryTag.className = 'getTextWidth';
      document.querySelector('body')?.appendChild(TemporaryTag);
      let currentElement = document.getElementsByClassName('getTextWidth') as HTMLCollectionOf<HTMLElement>;
      let currentWidth = currentElement[0].offsetWidth;
      document.querySelector('.getTextWidth')?.remove();
      // cellWidth为表格容器的宽度
      const cellWidth = obj.target.offsetWidth;
      // 当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行
      currentWidth <= 2 * cellWidth ? (row.showTooltip = false) : (row.showTooltip = true);
    };

    return {
      name,
      timeTableData,
      isLoading,
      spanMethod,
      showTips,
    };
  },
});
